import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { NavType, HEADER_DATA_SOURCE } from '..';
import { GET_NAV_ELIGIBILITY } from './headerOperations';
import { getVisibleLinks } from './mainNavLinks';
/**
 * This hook fetches user eligibility for current NavLink type.
 * @param currentNavType Current navLink on which website is currently on
 * @param isUserLoggedIn This skips the GQL call if user is not logged in.
 * @returns object of type `EligibilityCriteria`
 * */

export function useEligibility( // eslint-disable-line @typescript-eslint/no-explicit-any
currentNavType, isUserLoggedIn) {
  // TODO: Abstract eligibility detection for loose-coupling https://chegg.atlassian.net/browse/ME-9900
  var skipGQL = false;
  var QUERY = GET_NAV_ELIGIBILITY;

  switch (currentNavType) {
    case NavType.home:
    case NavType.study:
      QUERY = GET_NAV_ELIGIBILITY;
      break;

    default:
      skipGQL = true;
      break;
  }

  var _useQuery = useQuery(QUERY, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    // This variable is required to log traffic into NewRelic coming from different clients
    variables: {
      navType: currentNavType
    },
    ssr: false,
    skip: !isUserLoggedIn || skipGQL,
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  }),
      data = _useQuery.data,
      error = _useQuery.error;

  return {
    data: data,
    error: error
  };
}
/**
 * This hook filters out and return only visible links that pass the defined criteria
 * @param currentNavType Current navLink on which website is currently on
 * @param originalLinks Raw link data from which only visible links are taken into consideration
 * @param user Current user object. It's _optional_ because some criteria may not require this
 * @returns object of type `EligibilityCriteria`
 * */

export function useVisibleLinks(currentNavType, originalLinks, user) {
  var eligibility = useEligibility(currentNavType, !!user);

  function getLinks() {
    return getVisibleLinks(originalLinks, _objectSpread(_objectSpread({}, eligibility), {}, {
      user: user
    }));
  }

  var _useState = useState(getLinks()),
      _useState2 = _slicedToArray(_useState, 2),
      links = _useState2[0],
      setLinks = _useState2[1];

  useEffect(function () {
    setLinks(getLinks());
  }, [
  /* istanbul ignore next - skipping because of optional chaining failure in test-cases */
  eligibility === null || eligibility === void 0 ? void 0 : eligibility.data]);
  return {
    links: links,
    eligibility: eligibility
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/useVisibleEligibility.js
// module id = 1637
// module chunks = 11